export default function () {
  return {
    areas: [],
    area: {
      name: '',
      initials: '',
      parent_id: null,
      area_level_id: 1
    },
    areaList: [],
    areaAllList: [],
    areaLevels: [
      {
        id: 1,
        label: 'Level 1'
      },
      {
        id: 2,
        label: 'Level 2'
      },
      {
        id: 3,
        label: 'Level 3'
      }
    ],
    areaLevel: {}
  }
}
